import request from '@/utils/request';

// ------------------------ 系统
// 登录
export const loginApi = params => {
  return request.post('/mall/loginAdmin', params);
};

// 短信验证码登录
export const messageloginApi = params => {
  return request.post('/mall/sms/login', params);
};

// 获取验证码
export const getCaptchaInfoApi = params => {
  return request.get('/mall/captchaImage', params);
};

// 发送短信验证码
export const sendSmsApi = mobile => {
  return request.post('/mall/system/smsCode', {
    mobile,
  });
};

// 获取用户信息
export const getLoginUserInfoApi = () => {
  return request.get('/mall/getInfo');
};

// 修改密码
export const updatePasswordApi = params => {
  return request.put('/mall/system/user/resetPwd', params);
};

// 退出登录
export const loginOutApi = () => {
  return request.put('/mall/logout');
};

// ------------------- 商品管理
// ------- 类别
// 类别查询
export const getCategoryListApi = () => {
  const params = {
    pageNum: 1,
    pageSize: 999,
  };
  return request.get('/mall/system/category/list', {
    params,
  });
};

// 新增类别
export const createCategoryApi = params => {
  return request.post('/mall/system/category', params);
};

// 修改类别
export const updateCategoryApi = params => {
  return request.put('/mall/system/category', params);
};

// 删除类别
export const deleteCategoryApi = ids => {
  return request.delete('/mall/system/category/' + ids);
};

// 分类排序
export const sortCategoryApi = ids => {
  return request.post('/mall/system/category/sortCategory', { ids });
};

// ------- 商品
// 商品查询
export const getGoodsListApi = params => {
  return request.get('/mall/system/goods/list', {
    params,
  });
};

// 根据id查询商品
export const queryGoodsByIdApi = id => {
  return request.get(`/mall/system/goods/${id}`);
};

// 新增商品
export const createGoodsApi = params => {
  return request.post('/mall/system/goods', params);
};

// 修改商品
export const updateGoodsApi = params => {
  return request.put('/mall/system/goods', params);
};

// 删除商品
export const deleteGoodsApi = ids => {
  return request.delete('/mall/system/goods/' + ids);
};

// 上架商品
export const goodsUpApi = id => {
  return request.post(`/mall/system/goods/up/${id}`);
};

// 下架商品
export const goodsDownApi = id => {
  return request.post(`/mall/system/goods/down/${id}`);
};

// 商品置顶取消
export const openCloseActivityApi = (goodsId, flag) => {
  return request.put(`/mall/system/goods/openCloseActivity/${goodsId}/${flag}`);
};

// 商品活动设置
export const goodsSetActivity = params => {
  return request.post(`/mall/system/goods/setActivity`, params);
};

// 商品置顶取消
export const goodsTopOrCancelApi = (id, isTop) => {
  return request.put(`/mall/system/goods/topOrCancel/${id}/${isTop}`);
};

// ------------------- 小程序首页banner
// banner查询
export const getBannerListApi = params => {
  return request.get('/mall/system/img/list', {
    params,
  });
};

// 新增banner
export const createBannerApi = params => {
  return request.post('/mall/system/img', params);
};

// 修改banner
export const updateBannerApi = params => {
  return request.put('/mall/system/img', params);
};

// 删除banner
export const deleteBannerApi = ids => {
  return request.delete('/mall/system/img/' + ids);
};

// ------------------- 许愿池

// 查询许愿池的基本信息
export const getSystemWellInfoApi = params => {
  return request.get('/mall/system/well/info', {
    params,
  });
};

// 修改许愿池基本信息
export const updateSystemWellInfoApi = params => {
  return request.put('/mall/system/well', params);
};

// 获取捐款记录
export const getSystemWellRecordListApi = params => {
  return request.get('/mall/system/record/list', {
    params,
  });
};

// 获取消费记录
export const orderQueryExpendApi = params => {
  return request.get('/mall/system/order/queryExpend', {
    params,
  });
};

// ------------------------ 大师视频
// 大师视频列表
export const masterVideoListApi = () => {
  return request.get('/mall/system/img/videoList');
};

// 新增视频
export const addMasterVideoApi = params => {
  return request.post('/mall/system/img/addVideo', params);
};

// 删除大师视频
export const deleteMasterVideoListApi = id => {
  return request.delete(`/mall/system/img/deleteVideo/${id}`);
};

// 静态数据
// 查询省市区数据字典
export const getSystemDictListApi = () => {
  return request.get('/mall/system/dict/list');
};

// ------------------- 寺庙地址管理
// 寺庙地址查询
export const getTempleListApi = params => {
  return request.get('/mall/system/address/list', {
    params,
  });
};

// 新增寺庙地址
export const createTempleApi = params => {
  return request.post('/mall/system/address', params);
};

// 修改寺庙地址
export const updateTempleApi = params => {
  return request.put('/mall/system/address', params);
};

// 删除寺庙地址
export const deleteTempleApi = ids => {
  return request.delete('/mall/system/address/' + ids);
};

// ------------------- 账号管理
// 查询用户列表
export const queryUserListManagerApi = params => {
  return request.get('/mall/system/user/listManager', {
    params,
  });
};

// 删除账号
export const deleteUserApi = userId => {
  return request.delete(`/mall/system/user/manager/${userId}`);
};

// 新增账号
export const addUserApi = params => {
  return request.post('/mall/system/user/addUser', params);
};

// 修改账号
export const editUserApi = params => {
  return request.put(`/mall/system/user/editManager`, params);
};

// ------------------- 订单管理
// 查询订单列表
export const queryOrderListApi = params => {
  return request.get('/mall/system/order/list', {
    params,
  });
};

// 查询订单详情
export const queryOrderDetailApi = id => {
  return request.get(`/mall/system/order/${id}`);
};

// 查询物流公司列表
export const queryDeliveryCompanyListApi = params => {
  return request.get('/mall/system/company/list', {
    params,
  });
};

// 查询物流信息
export const queryDeliveryInfoApi = (orderId, orderItemId) => {
  return request.get(
    `/mall/system/company/companyCode/${orderId}/${orderItemId}`
  );
};

// 回填物流单号
export const setOrderDeliveryApi = (orderItemId, deliveryNumber, deliveryId) => {
  return request.put(`/mall/system/order/${orderItemId}/${deliveryNumber}/${deliveryId}`);
};


// 回填物流单号(新 - 支持自提)
export const setDeliveryInfoApi = (params) => {
  return request.put(`/mall/system/order/setDelivery`, params);
};


// 更新物流单号
export const updateOrderDeliveryApi = (orderItemId, deliveryNumber, deliveryId) => {
  return request.put(
    `/mall/system/order/updateDeliveryInfo/${orderItemId}/${deliveryNumber}/${deliveryId}`
  );
};

// 更改订单状态（已支付更改为待发货）
export const setOrderStatusByIdApi = id => {
  return request.put(`/mall/system/order/setOrderStatus/${id}`);
};

// ------- 金刚区
// 查询金刚区
export const getPageMediaListApi = () => {
  return request.get(`/mall/system/page/list`);
};

// 设置金刚区
export const setHomePageApi = params => {
  return request.post(`/mall/system/page/addHomePage`, params);
};

// ------- 推荐
// 推荐列表
export const wechatRecordListApi = () => {
  return request.get(`/mall/system/wechatRecord/list`);
};

// 审核
export const wechatRecordReviewerApi = (id, status) => {
  return request.put(`/mall/system/wechatRecord/reviewer/${id}/${status}`);
};
